import type { SVGProps } from 'react';

/**
 * YouTube brand icon — replicated verbatim from the Figma design system
 * ("Social icon" page, node 5422:4239). Full-colour (red badge + white play);
 * `color`/`fill` props do not tint it. Single source of truth for the YT mark.
 */
export function YoutubeIcon({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.4489 7.75577C26.1501 6.63801 25.2697 5.75744 24.1517 5.45865C22.1254 4.91581 13.9999 4.91581 13.9999 4.91581C13.9999 4.91581 5.87461 4.91581 3.84826 5.45865C2.73028 5.75744 1.84993 6.63801 1.55113 7.75577C1.00808 9.78233 1.00808 14.01 1.00808 14.01C1.00808 14.01 1.00808 18.2379 1.55113 20.2642C1.84993 21.382 2.73028 22.2627 3.84826 22.5613C5.87461 23.1044 13.9999 23.1044 13.9999 23.1044C13.9999 23.1044 22.1254 23.1044 24.1517 22.5613C25.2697 22.2627 26.1501 21.382 26.4489 20.2642C26.9919 18.2379 26.9919 14.01 26.9919 14.01C26.9919 14.01 26.9919 9.78233 26.4489 7.75577Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4016 17.9076L18.152 14.0102L11.4016 10.1124V17.9076Z"
        fill="white"
      />
    </svg>
  );
}
